import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  lighten,
  List,
  ListItem,
  ListItemText,
  TextField,
  Checkbox,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close as CloseIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import Info from '.';
import { turnOnCloneUserState, warehouseState } from 'atoms/WarehouseState';
import { WarehouseUserListState } from 'atoms/WarehouseUserListState';
import { warehouseUserState } from 'atoms/WarehouseUserState';
import { addWarehouseUsers, deleteWarehouseUser, listUsers } from 'repositories/HttpRepository';
import CloneUser from './cloneUsers';

const headCells = [
  { id: 'id', label: 'User ID', align: 'center' },
  { id: 'username', label: 'User Name' },
  { id: 'email', label: 'Email' },
  { id: 'role', label: 'Role', align: 'center', isDisableSort: true },
  { id: 'action', label: '', align: '' },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, headCells } = props;
  const tmpHeadCells = [...headCells];
  tmpHeadCells.pop();
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            color="primary"
            size="small"
            slotProps={{
              input: { 'aria-label': 'select all desserts' },
            }}
          />
        </TableCell>
        {tmpHeadCells.map((headCell) => (
          <TableCell key={headCell.id} align={headCell.align ? headCell.align : 'left'}>
            <Table>{headCell.label}</Table>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    padding: 20,
  },
  DialogContent: {
    backgroundColor: '#fff',
  },
  Paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    overflowY: 'auto',
    boxShadow: 'none',
    minHeight: 200,
    maxHeight: 350,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },

  Table: {
    marginTop: 20,

    '& thead': {
      backgroundColor: theme.palette.secondary.main,

      '& th': {
        color: '#fff',
      },
    },
    '& tbody': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
  },
  AddBtn: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  SearchIcon: {
    color: '#bebfc0',
  },
  CloseBtn: {
    padding: theme.spacing(1),
  },
  AddedUsers: {
    '& span': {
      fontSize: 14,
    },
    '& li': {
      padding: 0,
    },
  },
  EmptyRow: {
    height: 45,
  },
  closeBtn: {
    position: 'absolute',
    right: 20,
    top: 20,
    color: '#d8d8d8',
    fontSize: 30,
    cursor: 'pointer',
  },
  ExplainText: {
    marginTop: 15,
    fontSize: 16,
    fontWeight: 700,
    color: '#545454',
    position: 'relative',
    top: 10,
  },
}));

function UserInfo(props) {
  const { datas, warehouse_id } = props;
  const { classes } = useStyles();
  const [selected, setSelected] = React.useState([]);
  const [addedUsers, setAddedUsers] = React.useState([]);
  const [turnOnAddUser, setTurnOnAddUser] = useState(false);
  const [searchAction, setSearchAction] = useState(false);
  const [loading, setLoading] = useState(false);

  const [turnOnCloneUser, setTurnOnCloneUser] = useRecoilState(turnOnCloneUserState);

  const [users, setUsers] = useRecoilState(WarehouseUserListState);
  const [existedUsers, setExistedUsers] = useRecoilState(warehouseUserState);

  let existedUserIds = [];
  existedUsers.forEach((existedUser) => {
    existedUserIds.push(existedUser.id);
  });

  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  function handleSearch(e) {
    setKeyword(e.target.value);
  }

  function handleResetSearch(e) {
    setKeyword('');
    setSelected([]);
    setUsers([]);
    setSearchAction(false);
  }

  function handleKeyDown(e) {
    let keyword = e.target.value;

    if (e.key !== 'Enter') {
      return;
    }

    // Reset selected
    setSelected([]);

    if (keyword === '') {
      e.preventDefault();
      return;
    }

    setSearchAction(true);
    setLoading(true);
    listUsers({ username: keyword }).then((resp) => {
      setLoading(false);
      if (resp.ok) {
        setUsers(resp.data.items);
      } else {
        return;
      }
    });
    e.preventDefault();
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function handleDisplayScreen(e) {
    setTurnOnAddUser(true);
  }

  function handleDisplayScreen2(e) {
    setTurnOnCloneUser(true);
  }

  function handAddUser(e) {
    let tmp = [...addedUsers];

    selected.forEach((selectedID) => {
      // check existed in list
      let existed = false;
      tmp.forEach((el) => {
        if (selectedID === el.id) {
          existed = true;
        }
      });

      if (existed === true) {
        return;
      }

      let userInfo = {};
      users.forEach((user) => {
        if (user.id === selectedID) {
          userInfo = user;
        }
      });

      if (Object.keys(userInfo).length === 0) {
        return;
      }

      tmp.push(userInfo);
    });
    setAddedUsers(tmp);
  }

  function removeAddedUser(userId) {
    let tmp = addedUsers.filter((obj) => {
      return obj.id !== userId;
    });
    setAddedUsers(tmp);
  }

  function processData(datas) {
    let result = [];
    datas.forEach((data) => {
      result.push({
        id: data.id,
        name: data.username,
        email: data.email,
        _scopes: data._scopes,
      });
    });

    return result;
  }

  function handleSave(e) {
    if (addedUsers.length === 0) {
      return;
    }
    // no-dd-sa:javascript-code-style/assignment-name
    let user_ids = [];
    addedUsers.forEach((addedUser) => {
      user_ids.push(addedUser.id);
    });

    addWarehouseUsers(warehouse_id, user_ids).then((res) => {
      if (res.ok) {
        toast.success('added users !');
        let tmp = [...existedUsers];
        setExistedUsers(tmp.concat(addedUsers));

        turnOffAddUser();
      } else {
        toast.error('Server is having problem, please try again later.');
      }
    });
  }

  // no-dd-sa:javascript-code-style/parameter-name
  function handleRemoveUser(user_id) {
    deleteWarehouseUser(warehouse_id, user_id).then((res) => {
      if (res.ok) {
        toast.success('remove successfully !');
        let tmp = existedUsers.filter((obj) => {
          return obj.id !== user_id;
        });
        setExistedUsers(tmp);
      } else {
        toast.error('Server is having problem, please try again later.');
      }
    });
  }

  function turnOffAddUser() {
    setTurnOnAddUser(false);
    setKeyword(null);
    setAddedUsers([]);
    setUsers([]);
    setSearchAction(false);
  }

  let addedUserNumber = 0;
  if (users.length) {
    users.forEach((row) => {
      if (existedUserIds.includes(row.id)) {
        addedUserNumber++;
      }
    });
  }

  return (
    <div>
      <Info
        key="userInfo"
        title="Users Info"
        labelAddBtn="Add Users"
        displayAddScreen={handleDisplayScreen}
        labelAddBtn2="Clone Users"
        displayAddScreen2={handleDisplayScreen2}
        headings={headCells}
        remove={handleRemoveUser}
        removeLabelApprove="YES, remove user"
        datas={processData(datas)}
      />
      {turnOnAddUser && (
        <Dialog
          open={true}
          onClose={() => {
            /** empty */
          }}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          className={classes.DialogRoot}
        >
          <DialogTitle id="form-dialog-title" variant="h5" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
            Add user
            <CloseIcon className={classes.closeBtn} onClick={turnOffAddUser} />
          </DialogTitle>
          <DialogContent className={classes.DialogContent} dividers>
            <form>
              <TextField
                onChange={handleSearch}
                onKeyDown={handleKeyDown}
                variant="outlined"
                id="standard-start-adornment"
                placeholder="Search users by user ID, username, email…"
                fullWidth
                value={keyword}
                size="small"
                className={classes.searchInput}
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment className={classes.SearchIcon} position="start"></InputAdornment>,
                    endAdornment: keyword && (
                      <IconButton className={classes.CloseBtn} onClick={handleResetSearch} size="large">
                        <CloseIcon />
                      </IconButton>
                    ),
                  },
                }}
              />
            </form>
            <div className={classes.Table}>
              <Paper className={classes.Paper}>
                <TableContainer>
                  <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                    <EnhancedTableHead
                      classes={classes}
                      numSelected={selected.length}
                      onSelectAllClick={handleSelectAllClick}
                      rowCount={users.length}
                      headCells={headCells}
                    />
                    <TableBody>
                      {Array.isArray(users) && users.length !== 0 && addedUserNumber < users.length
                        ? users.map((row, index) => {
                            if (existedUserIds.includes(row.id)) {
                              return;
                            }
                            const isItemSelected = isSelected(row.id);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                hover
                                onClick={(event) => handleClick(event, row.id)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.id}
                                selected={isItemSelected}
                              >
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    checked={isItemSelected}
                                    size="small"
                                    color="primary"
                                    slotProps={{
                                      input: { 'aria-labelledby': labelId },
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="left">{row.username}</TableCell>
                                <TableCell align="left">{row.email}</TableCell>
                                <TableCell align="center">{row._scopes}</TableCell>
                              </TableRow>
                            );
                          })
                        : [1, 2, 3, 4, 5].map((row, index) => {
                            return (
                              <TableRow className={classes.EmptyRow}>
                                <TableCell align="center" colSpan={5} key={`empty-row-${index}`}>
                                  {keyword != null &&
                                  keyword !== '' &&
                                  searchAction === true &&
                                  loading === false &&
                                  row === 1
                                    ? 'No result !'
                                    : null}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </div>
            <div className={classes.AddBtn}>
              <Typography variant="h6">Added users:</Typography>
              <Button
                onClick={handAddUser}
                size="medium"
                color="primary"
                variant="contained"
                disabled={selected.length === 0}
              >
                ADD
              </Button>
            </div>
            <List className={classes.AddedUsers}>
              {addedUsers.map((user, index) => {
                return (
                  <ListItem key={`added-user-${index}`}>
                    <ListItemText>
                      {index + 1}. username: {user.username}, ID: {user.id}, {user._scopes}
                    </ListItemText>
                    <Link onClick={(e) => removeAddedUser(user.id)}>Remove</Link>
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="inherit" onClick={turnOffAddUser}>
              CANCEL
            </Button>
            <Button variant="contained" color="primary" disabled={addedUsers.length === 0} onClick={handleSave}>
              SAVE
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {turnOnCloneUser && <CloneUser warehouse_id={warehouse_id} />}
    </div>
  );
}

export default React.memo(UserInfo);
